import StoredLayout from '../../layouts/StoredLayout'
import SocialMediaButtons from './SocialMediaButtons'
export default StoredLayout(SocialMediaButtons)
